var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 5.6H3.7C2.2 5.6.9 6.9.9 8.4v15.7c0 1.5 1.3 2.8 2.8 2.8h24.6c1.5 0 2.8-1.3 2.8-2.8V8.4c0-1.6-1.2-2.8-2.8-2.8M24.9 9l-7.5 5.3c-.5.3-.9.7-1.2 1.1-.3-.4-.7-.7-1.2-1.1L7.5 9zm2.9 14.5H4.2V11.9l8.3 5.8c1.2.9 2.6 1.2 3.5 1 .9.3 2.4-.1 3.7-1l7.9-5.5v11.3z"
  })));
};
export default SvgEnvelope;